module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAAAXNSR0IArs4c6QAAATFJREFUSA3tVjFuwkAQ3LkiFQoi6XlALOURFEj8I01aHkIX0fgfkSj8iEjmAfQkAlGl8GZ2jRFBQTIym4ptbJ/2Znbn1pqDnMR6+JSJ6osIxqIyFNHeScofn9gJZMXchQD542pZHieh+dAsu/vaVjMCv6pIatYvfRKwIuF8cJ+mKMtv2+8kRvC50XdWMroU9Hw+ioc+JkbkFXsHVyUwah3VuOzEzgCVfnSR6Fw3Jp0mPCc75AgC78XOlviUi1MUGhiTycY0MIjPTtr8B12K0J5PVxeINntvJG1UOuTc5DpI0eblv+Si4YQGdql2tEAWOiblomWGhi7YCXK3zACi2oqRJzd9enIAh5n73PB9usz0uVJclwhFjbu/lZjZu+lD3rpKZ/tBnOYSYYVz7XdE3Lt+AFJwaUqxwWZ7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/map/images/red-marker.png
// module id = 1174
// module chunks = 0